import type { GameSymbol } from "@/app/games.mjs";
import type { ClassNameEntry } from "@/util/class-names.mjs";
import { proxy } from "@/util/proxy.mjs";

interface AppRefs {
  SignIn: React.FC;

  getBearerToken?: () => Promise<string | null>;

  accountMenuItems: {
    slotOne: React.FC<{
      className?: string;
      onClick: React.MouseEventHandler<HTMLAnchorElement>;
    }>;

    slotTwo: React.FC<{
      className?: string;
      onClick: React.MouseEventHandler<HTMLAnchorElement>;
    }>;

    footerSlot: React.FC<{
      className?: string;
      onClick: React.MouseEventHandler<HTMLAnchorElement>;
    }>;
  };

  onComingSoonNotifySubmitted: (
    gameSymbol: GameSymbol,
    email: string,
  ) => Promise<boolean>;

  onMatchtileShare: (
    gameSymbol: GameSymbol,
    gameData: object,
  ) => Promise<boolean>;

  fetchedFeatureFlags: Promise<void> & { resolve: () => void };

  userPreferenceUpdatePromise: Promise<void> | null;

  appShell: {
    titleBarClasses: Array<ClassNameEntry>;
    TitleBar: React.FC<{ className: string }>;
    ContentHeader: React.FC;
    AppHeaderNotification: React.FC;
    Snackbar: React.FC;
    GamePromoFeatures: React.FC;
    OmniSearchModal: React.FC;
  };
}

export const appRefs = proxy<AppRefs>({
  SignIn: null,

  getBearerToken: () => Promise.resolve(null),

  accountMenuItems: proxy({
    slotOne: null,
    slotTwo: null,
    footerSlot: null,
  }),

  onComingSoonNotifySubmitted: null,
  onMatchtileShare: null,

  fetchedFeatureFlags: (() => {
    let resolve;
    const promise = new Promise<void>((res) => {
      resolve = res;
    });
    return Object.assign(promise, { resolve });
  })(),

  userPreferenceUpdatePromise: Promise.resolve(),

  appShell: {
    titleBarClasses: [],
    TitleBar: () => null,
    AppHeaderNotification: () => null,
    ContentHeader: () => null,
    Snackbar: () => null,
    GamePromoFeatures: () => null,
    OmniSearchModal: () => null,
  },
});

export default appRefs;
